import React from 'react';
import { useIntl } from 'react-intl';
import { Badge } from 'reactstrap';
import { PresaveCampaignStatus } from 'fym-shared/src/smartlinks/presave';
import { TypedMemo } from '../../common/types';

interface PresaveStatusBadgeProps {
  status: PresaveCampaignStatus;
}

/** Where the campaign stands. IDs are spelled out: the extractor needs them static. */
const PresaveStatusBadgeComponent: React.FC<PresaveStatusBadgeProps> = ({ status }) => {
  const intl = useIntl();

  switch (status) {
    case PresaveCampaignStatus.released:
      return (
        <Badge color="success">
          {intl.formatMessage({ id: 'app.sml.presave.status.released', defaultMessage: 'Released' })}
        </Badge>
      );
    case PresaveCampaignStatus.expired:
      return (
        <Badge color="warning">
          {intl.formatMessage({ id: 'app.sml.presave.status.expired', defaultMessage: 'Expired' })}
        </Badge>
      );
    case PresaveCampaignStatus.cancelled:
      return (
        <Badge color="secondary">
          {intl.formatMessage({ id: 'app.sml.presave.status.cancelled', defaultMessage: 'Cancelled' })}
        </Badge>
      );
    case PresaveCampaignStatus.scheduled:
    default:
      return (
        <Badge color="info">
          {intl.formatMessage({ id: 'app.sml.presave.status.scheduled', defaultMessage: 'Scheduled' })}
        </Badge>
      );
  }
};

export const PresaveStatusBadge = TypedMemo(PresaveStatusBadgeComponent);
